const SW_UPDATE_EVENT = 'launchpoint-sw-update-available';

/** Dispatched when a new service worker is waiting (see registerServiceWorker). */
export function dispatchSwUpdateAvailable(): void {
  window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT));
}

export function subscribeSwUpdateAvailable(handler: () => void): () => void {
  window.addEventListener(SW_UPDATE_EVENT, handler);
  return () => window.removeEventListener(SW_UPDATE_EVENT, handler);
}
